import { render, staticRenderFns } from "./garanziePolizze.vue?vue&type=template&id=0e67c54c&"
import script from "./garanziePolizze.vue.ts?vue&type=script&lang=ts&"
export * from "./garanziePolizze.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports